import React, { Fragment } from 'react';
import { FormHelperText, Grid } from '@material-ui/core';

const getErrorArray = (errStr) => {
  try {
    const array = JSON.parse(errStr.message);
    return array;
  } catch (error) {
    return ['Oops, something went wrong! Sorry, please try again later.'];
  }
}

const ErrorMessage = ({ errorMessage }) => {
  const errorArray = getErrorArray(errorMessage);
  return (
    <Fragment>
      {errorArray.map( (err, i) => 
        <Grid key={i} item xs={12}>
          <FormHelperText error={true}>
            {err}
          </FormHelperText>
        </Grid>
      )}
    </Fragment>
  )
}

export default ErrorMessage;
